import { FC, useEffect, useState } from "react";
import { Isummary, QuizQuestion } from "../../models/quizModel";
import SingleQuestion from "./SingleQuestion";
import SVG from "react-inlinesvg";
import { useMutation } from "@tanstack/react-query";
import { submitQuizList } from "../../api/Quiz";
import { toast } from "react-toastify";
import SummeryComponent from "./summery";

interface Props {
  QeustionSet: QuizQuestion[];
  name: string;
  slug?: string;
  refetchQuestionSet: () => void;
}
interface qnList {
  question_id: number;
  answer_id: number[] | [];
  quiz_id: number;
}

const QuizCourse: FC<Props> = ({
  QeustionSet,
  name,
  slug,
  refetchQuestionSet,
}) => {
  const [section1, setSection1] = useState<QuizQuestion[]>([]);
  const [section2, setSection2] = useState<QuizQuestion[]>([]);
  const [qnList, setQnList] = useState<qnList[]>([]);
  const [finishQuiz, setFinishQuiz] = useState<boolean>(false);
  const [summary, setSummary] = useState<Isummary[]>();

  // New state for one-by-one display
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [currentSection, setCurrentSection] = useState<"section1" | "section2">(
    "section1"
  );
  const [allQuestions, setAllQuestions] = useState<QuizQuestion[]>([]);

  // Generate dynamic set sequence from A to Z
  const generateSetSequence = () => {
    const sets = [];
    for (let i = 65; i <= 90; i++) {
      // ASCII values: A=65, Z=90
      sets.push(`Set ${String.fromCharCode(i)}`);
    }
    return sets;
  };

  // Dynamic set sequence A-Z
  const setSequence = generateSetSequence();

  // Track the current set
  const [currentSet, setCurrentSet] = useState<string>(setSequence[0]);
  // Track current set index
  const [currentSetIndex, setCurrentSetIndex] = useState<number>(0);

  const SUbmitQuizMutation = useMutation({
    mutationKey: ["submitQuiz"],
    mutationFn: (qnList: qnList[]) => submitQuizList(qnList),
    onSuccess: (data) => {
      setQnList([]);
      setSummary(data?.data);
    },
    onError: (error: any) => {
      if (error.response.data) {
        toast.error(error.response.data);
      } else {
        toast.error("Something went wrong");
      }
    },
  });

  useEffect(() => {
    setQnList(
      QeustionSet.map((e) => {
        return {
          question_id: e.id || 0,
          answer_id: [],
          quiz_id: e.quiz_id || 0,
        };
      })
    );
  }, [QeustionSet]);

  function aadQnList(
    question_id: number,
    answer_id: number,
    type: string,
    quiz_id: number
  ) {
    if (type === "mcq") {
      const qnListCopy = [...qnList];
      const index = qnListCopy.findIndex((e) => e.question_id === question_id);
      if (index === -1) {
        qnListCopy.push({
          question_id,
          answer_id: [answer_id],
          quiz_id: quiz_id || 0,
        });
      } else {
        qnListCopy[index].answer_id = [answer_id];
      }
      setQnList(qnListCopy);
    }
    if (type === "true/false") {
      const qnListCopy = [...qnList];
      const index = qnListCopy.findIndex((e) => e.question_id === question_id);
      if (index === -1) {
        qnListCopy.push({
          question_id,
          answer_id: [answer_id],
          quiz_id: quiz_id || 0,
        });
      } else {
        qnListCopy[index].answer_id = [answer_id];
      }
      setQnList(qnListCopy);
    }
    if (type === "checkbox") {
      const qnListCopy = [...qnList];
      const index = qnListCopy.findIndex((e) => e.question_id === question_id);
      if (index === -1) {
        qnListCopy.push({
          question_id,
          answer_id: [answer_id],
          quiz_id: quiz_id || 0,
        });
      } else {
        qnListCopy[index].answer_id = [
          ...qnListCopy[index]?.answer_id,
          answer_id,
        ];
      }
      setQnList(qnListCopy);
    }
  }

  const HandleFinishQuiz = async () => {
    setFinishQuiz(true);
    await SUbmitQuizMutation.mutate(qnList);
  };

  const handleContinue = async () => {
    window.scrollTo(0, 0);
    if (!summary) {
      await SUbmitQuizMutation.mutate(qnList);
    } else {
      // Update to the next set when continuing
      const nextSetIndex = (currentSetIndex + 1) % setSequence.length;
      setCurrentSetIndex(nextSetIndex);
      setCurrentSet(setSequence[nextSetIndex]);

      // Reset states for the new set
      setSummary(undefined);
      setSection1([]);
      setSection2([]);
      setFinishQuiz(false);
      setCurrentQuestionIndex(0);
      setCurrentSection("section1");
      setAllQuestions([]);

      refetchQuestionSet();
    }
  };

  // Handle next question
  const handleNextQuestion = () => {
    if (currentSection === "section1") {
      if (currentQuestionIndex < section1.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
      } else if (section2.length > 0) {
        setCurrentSection("section2");
        setCurrentQuestionIndex(0);
      }
    } else {
      if (currentQuestionIndex < section2.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
      }
    }
  };

  // Handle previous question
  const handlePrevQuestion = () => {
    if (currentSection === "section2") {
      if (currentQuestionIndex > 0) {
        setCurrentQuestionIndex(currentQuestionIndex - 1);
      } else if (section1.length > 0) {
        setCurrentSection("section1");
        setCurrentQuestionIndex(section1.length - 1);
      }
    } else {
      if (currentQuestionIndex > 0) {
        setCurrentQuestionIndex(currentQuestionIndex - 1);
      }
    }
  };

  // Check if current question is answered
  const isCurrentQuestionAnswered = () => {
    const currentQuestion =
      currentSection === "section1"
        ? section1[currentQuestionIndex]
        : section2[currentQuestionIndex];
    if (!currentQuestion || !currentQuestion.id) return false;

    const answerEntry = qnList.find(
      (q) => q.question_id === currentQuestion.id
    );
    return answerEntry && answerEntry.answer_id.length > 0;
  };

  // Check if it's the last question
  const isLastQuestion = () => {
    return currentSection === "section2"
      ? currentQuestionIndex === section2.length - 1
      : section2.length === 0 && currentQuestionIndex === section1.length - 1;
  };

  // Check if it's the first question
  const isFirstQuestion = () => {
    return currentSection === "section1" && currentQuestionIndex === 0;
  };

  // Get current question number and total
  const getCurrentQuestionNumber = () => {
    if (currentSection === "section1") {
      return currentQuestionIndex + 1;
    } else {
      return section1.length + currentQuestionIndex + 1;
    }
  };

  const getTotalQuestions = () => {
    return section1.length + section2.length;
  };

  useEffect(() => {
    if (QeustionSet?.length > 0) {
      // Clear previous sections when loading new questions
      setSection1([]);
      setSection2([]);
      setCurrentQuestionIndex(0);
      setCurrentSection("section1");

      QeustionSet.map((e) => {
        if (e.section === "Section 1") {
          setSection1((prev) => [...prev, e]);
        }
        if (e.section === "Section 2") {
          setSection2((prev) => [...prev, e]);
        }
      });
    }
  }, [QeustionSet]);

  if (summary) {
    return (
      <div className="container-fluid px-3 px-md-4">
        <SummeryComponent summary={summary} />
        <div className="d-flex flex-column flex-md-row justify-content-center mt-4 gap-3">
          <button className="btn btn-success" onClick={handleContinue}>
            Continue with quiz (
            {setSequence[(currentSetIndex + 1) % setSequence.length]})
          </button>
          <a
            href={`/courses/${slug}`}
            className="btn btn-primary d-flex align-items-center justify-content-center"
          >
            <SVG src="/media/icons/check-circle-fill.svg" className="me-2" />
            Finish quiz
          </a>
        </div>
      </div>
    );
  }

  const currentQuestion =
    currentSection === "section1"
      ? section1[currentQuestionIndex]
      : section2[currentQuestionIndex];

  return (
    <div className="container-fluid px-3 px-md-4">
      {SUbmitQuizMutation.isLoading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed"
          style={{ inset: "0px", backdropFilter: "blur(10px)", zIndex: "50" }}
        >
          <div className="spinner-border text-black" role="status">
            <span className="visually-hidden">Submitting...</span>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <h4 className="mb-2">
            {name} - {currentSet}
          </h4>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
            <h5 className="mb-2 mb-md-0">
              {currentSection === "section1" ? "Section 1" : "Section 2"}
            </h5>
            <div className="progress-info">
              <span className="badge bg-primary fs-6">
                Question {getCurrentQuestionNumber()} of {getTotalQuestions()}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="progress" style={{ height: "8px" }}>
            <div
              className="progress-bar bg-primary"
              role="progressbar"
              style={{
                width: `${
                  (getCurrentQuestionNumber() / getTotalQuestions()) * 100
                }%`,
              }}
              aria-valuenow={getCurrentQuestionNumber()}
              aria-valuemin={0}
              aria-valuemax={getTotalQuestions()}
            ></div>
          </div>
          <small className="text-muted">
            Progress: {getCurrentQuestionNumber()} / {getTotalQuestions()}
          </small>
        </div>
      </div>

      {/* Current Question */}
      <div className="row">
        <div className="col-12">
          {currentQuestion && (
            <div className="card shadow-sm">
              <div className="card-body">
                <SingleQuestion
                  key={`${currentSection}-${currentQuestionIndex}`}
                  question={currentQuestion}
                  aadQnList={aadQnList}
                  qnList={qnList}
                  idx={currentQuestionIndex}
                  setQnList={setQnList}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
            <button
              className="btn btn-outline-secondary"
              onClick={handlePrevQuestion}
              disabled={isFirstQuestion()}
            >
              <i className="fas fa-arrow-left me-2"></i>
              Previous
            </button>

            <div className="d-flex flex-column flex-md-row gap-2">
              {!isLastQuestion() ? (
                <button
                  className="btn btn-primary"
                  onClick={handleNextQuestion}
                  disabled={!isCurrentQuestionAnswered()}
                >
                  Next
                  <i className="fas fa-arrow-right ms-2"></i>
                </button>
              ) : (
                <button
                  className="btn btn-success"
                  onClick={HandleFinishQuiz}
                  disabled={!isCurrentQuestionAnswered()}
                >
                  Finish Quiz
                  <i className="fas fa-check ms-2"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Question Overview (Optional - can be collapsed on mobile) */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <button
                className="btn btn-link p-0 text-decoration-none"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#questionOverview"
                aria-expanded="false"
                aria-controls="questionOverview"
              >
                <i className="fas fa-list me-2"></i>
                Question Overview
              </button>
            </div>
            <div className="collapse" id="questionOverview">
              <div className="card-body">
                <div className="row">
                  {section1.length > 0 && (
                    <div className="col-12 col-md-6 mb-3">
                      <h6>Section 1</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {section1.map((question, idx) => {
                          const isAnswered = (() => {
                            const foundQuestion = qnList.find(
                              (q) => q.question_id === question.id
                            );
                            return foundQuestion
                              ? foundQuestion.answer_id.length > 0
                              : false;
                          })();
                          const isCurrent =
                            currentSection === "section1" &&
                            currentQuestionIndex === idx;
                          return (
                            <button
                              key={idx}
                              className={`btn btn-sm ${
                                isCurrent
                                  ? "btn-primary"
                                  : isAnswered
                                  ? "btn-success"
                                  : "btn-outline-secondary"
                              }`}
                              onClick={() => {
                                setCurrentSection("section1");
                                setCurrentQuestionIndex(idx);
                              }}
                            >
                              {idx + 1}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  {section2.length > 0 && (
                    <div className="col-12 col-md-6 mb-3">
                      <h6>Section 2</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {section2.map((question, idx) => {
                          const isAnswered = (() => {
                            const foundQuestion = qnList.find(
                              (q) => q.question_id === question.id
                            );
                            return foundQuestion
                              ? foundQuestion.answer_id.length > 0
                              : false;
                          })();
                          const isCurrent =
                            currentSection === "section2" &&
                            currentQuestionIndex === idx;
                          return (
                            <button
                              key={idx}
                              className={`btn btn-sm ${
                                isCurrent
                                  ? "btn-primary"
                                  : isAnswered
                                  ? "btn-success"
                                  : "btn-outline-secondary"
                              }`}
                              onClick={() => {
                                setCurrentSection("section2");
                                setCurrentQuestionIndex(idx);
                              }}
                            >
                              {section1.length + idx + 1}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizCourse;

interface answers {
  is_correct: boolean;
  id: number;
  answer_text: string;
}
